import { render, staticRenderFns } from "./AllUsers.vue?vue&type=template&id=13c4c225&scoped=true&"
import script from "./AllUsers.vue?vue&type=script&lang=js&"
export * from "./AllUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c4c225",
  null
  
)

export default component.exports